import { render, staticRenderFns } from "./EnvironmentDESABILITADO.vue?vue&type=template&id=56c5dcbc&"
import script from "./EnvironmentDESABILITADO.vue?vue&type=script&lang=js&"
export * from "./EnvironmentDESABILITADO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports